import React, { useEffect, useState } from "react";
import "./memberdashboard.css";
import api from "../../services/axios";
import { Outlet, useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import DashboardIcon from "@mui/icons-material/Dashboard";
import Face3Icon from "@mui/icons-material/Face3";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import EventIcon from "@mui/icons-material/Event";
import HelpIcon from "@mui/icons-material/Help";
import EmailIcon from "@mui/icons-material/Email";
import LogoutIcon from "@mui/icons-material/Logout";
import { Link } from "react-router-dom";
import NotificationsIcon from "@mui/icons-material/Notifications";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CloseIcon from "@mui/icons-material/Close";

const Memberdashboard = () => {
  const [sidebar, setSideBar] = useState(false);

  const handleLogout = () => {
    // Check if the token exists in localStorage before removing it
    const token = localStorage.getItem("token");
    if (token) {
      localStorage.removeItem("token");
    }

    // Navigate to the login page
    navigate("/login");
  };

  const MemberSidebarData = [
    {
      title: "Dashboard",
      icon: <DashboardIcon sx={{ color: "#FC0" }} />,
      Link: "/myaccount",
      cName: "nav-text",
    },
    {
      title: "Profile",
      icon: <Face3Icon sx={{ color: "#FC0" }} />,
      Link: "/myaccount/profile",
      cName: "nav-text",
    },
    {
      title: "Messages",
      icon: <EmailIcon sx={{ color: "#FC0" }} />,
      Link: "/myaccount/profile",
      cName: "nav-text",
    },
    {
      title: "Payment",
      icon: <AccountBalanceWalletIcon sx={{ color: "#FC0" }} />,
      Link: "/myaccount/payment",
      cName: "nav-text",
    },
    {
      title: "Activities",
      icon: <EventIcon sx={{ color: "#FC0" }} />,
      Link: "/myaccount",
      cName: "nav-text",
    },
    {
      title: "Support",
      icon: <HelpIcon sx={{ color: "#FC0" }} />,
      Link: "/myaccount/support",
      cName: "nav-text",
    },
    {
      title: "Log Out",
      icon: <LogoutIcon htmlColor="red" />,
      cName: "nav-text",
      onClick: handleLogout,
    },
  ];

  const [userProfile, setUserProfile] = useState({});

  const navigate = useNavigate();

  const showSideBar = (state) => setSideBar(state);

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      api
        .get(`/auth/get_navdetails`, {
          headers: { Authorization: `Bearer ${storedToken.token}` },
          withCredentials: true,
        })
        .then((result) => {
          const userProfileData = result.data.userProfile; // Update this based on your actual API response structure

          if (userProfileData) {
            setUserProfile(userProfileData);
          } else {
            console.error("Invalid response structure:", result.data);
          }
        })
        .catch((err) => console.log(err));
    }
  }, []);

  return (
    <div className="memberDashboard_dashboard-container">
      <div className="memberDashboard_top_nav">
        <div className="memberDashboard_userProfileInfo">
          <div className="memberDashboard_menuSideBarDiv">
            <Link to="#" className="menu__bars">
              {sidebar ? (
                <CloseIcon onClick={() => setSideBar(false)} />
              ) : (
                <MenuIcon onClick={() => setSideBar(true)} />
              )}
            </Link>
            {sidebar && (
              <div
                className="memberDashboard_mobMenu"
                style={{ display: sidebar ? "block" : "none" }}
              >
                <nav className="memberDashboard_mob-menu">
                  <ul className="memberDashboard_mob-menu-items" >
                    <li>
                      <ul>
                        {MemberSidebarData.map((item, index) => {
                          return (
                            <li
                              key={index}
                              className={item.cName}
                              onClick={() => {
                                if (item.onClick) item.onClick();
                                setSideBar(false);
                              }}
                            >
                              {item.Link ? (
                                <Link to={item.Link}>
                                  {item.icon}
                                  <span>{item.title}</span>
                                </Link>
                              ) : (
                                <div className="logout__div">
                                  {item.icon}
                                  <span>{item.title}</span>
                                </div>
                              )}
                            </li>
                          );
                        })}
                      </ul>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </div>
          <p>Hi, {userProfile.FirstName}</p>
        </div>
        <div className="userInfo">
          <NotificationsIcon className="userNotificationIcon" />
          <div className="profileInfo">
            <AccountCircleIcon className="userAccountCircleIcon" />
            <div className="profileDropdown">
              <ul>
                <li onClick={() => navigate("/myaccount/profile")}>
                  View Profile
                </li>
                <li onClick={() => navigate("/myaccount/payment")}>
                  Make Payment
                </li>
                <li onClick={handleLogout}>Logout</li>
              </ul>
            </div>
            {/* <button className="loginBtn" onClick={handleLogout}>
              <a href="/login">Logout</a>
            </button> */}
          </div>
        </div>
      </div>
      <div className="outer__content">
        <nav className="nav-menu">
          <ul className="nav-menu-items">
            <li>
              {MemberSidebarData.map((item, index) => {
                return (
                  <li key={index} className={item.cName} onClick={item.onClick}>
                    {item.Link ? (
                      <Link to={item.Link}>
                        {item.icon}
                        <span>{item.title}</span>
                      </Link>
                    ) : (
                      <div>
                        {item.icon}
                        <span>{item.title}</span>
                      </div>
                    )}
                  </li>
                );
              })}
            </li>
          </ul>
        </nav>

        <div className="content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Memberdashboard;
